var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDevOpsCi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.7154 45.1301H29.0004M29.0004 45.1301H9.57039L4.71289 30.5576H24.1429L29.0004 45.1301Z",
    stroke: "#D41E4D",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2161 17.2008C47.2161 19.4553 46.3205 21.6175 44.7263 23.2117C43.1321 24.8058 40.97 25.7014 38.7155 25.7014C36.461 25.7014 34.2988 24.8058 32.7046 23.2117C31.1104 21.6175 30.2148 19.4553 30.2148 17.2008C30.2148 14.9463 31.1104 12.7841 32.7046 11.19C34.2988 9.59579 36.461 8.7002 38.7155 8.7002C40.97 8.7002 43.1321 9.59579 44.7263 11.19C46.3205 12.7841 47.2161 14.9463 47.2161 17.2008Z",
    stroke: "#D41E4D",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5725 45.1316H53.2875V36.2594C48.7339 34.0981 43.7554 32.9804 38.715 32.9878C36.2133 32.9878 33.7749 33.2574 31.4287 33.7699",
    stroke: "#D41E4D",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevOpsCi);
export default __webpack_public_path__ + "static/media/DevOps_CI.91d0a4783aca66105ea8a36072b14281.svg";
export { ForwardRef as ReactComponent };